export default __webpack_public_path__ + "static/media/Screenshot_gardenview1.f9e8b70b.png";